import { render, staticRenderFns } from "./TabDocuments.vue?vue&type=template&id=041760be&scoped=true"
import script from "./TabDocuments.vue?vue&type=script&lang=js"
export * from "./TabDocuments.vue?vue&type=script&lang=js"
import style0 from "./TabDocuments.vue?vue&type=style&index=0&id=041760be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041760be",
  null
  
)

export default component.exports